import {
  DOCUMENT_CREATE,
  DOCUMENT_FETCH,
  DOCUMENT_UPDATE,
} from '../actions/types';

const INITIAL_STATE = { 
  documents: null,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
switch (action.type) {
      case DOCUMENT_CREATE:
      case DOCUMENT_UPDATE:
          return { ...state, loading: action.payload }
      case DOCUMENT_FETCH:
          return { ...state, documents: action.payload }
      default:
          return state
  }
}